import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpEvent
} from "@angular/common/http";

import { AuthService } from "./services/auth.service";

import { Injectable, Inject } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.auth.getUserToken();
    if (token) {
      const cloned = req.clone({
        headers: req.headers.set("Authorization", "bearer " + token)
      });
      return next.handle(cloned);
    } else {
      return next.handle(req);
    }
  }
}
